import React, {useState, useCallback} from 'react';
import { connect } from "react-redux";
import ethereum from 'decentralized/ethereum.js';
import ConditionedComponent from 'components/ConditionedComponent.js';
import FoldersComponent from 'components/folders/FoldersComponent.js';
import XanaduFolders from 'components/folders/XanaduFolders.js';

const COLLAPSED_WIDTH = 30;
const PRESETS = 'PRESETS';
const SEQUENCES = 'SEQUENCES';

function SideBrowserContainer(props) {
    const [collapsed, setCollapsed]  = useState(false);
    const [searchText, setSearchText]  = useState('');
    const [option, setOption]  = useState(PRESETS);

    const toggleCollapse = useCallback(() => {
        setCollapsed(!collapsed);
    }, [setCollapsed, collapsed]);

    let style = {};
    if (collapsed) {
        style['minWidth'] = COLLAPSED_WIDTH;
        style['width'] = COLLAPSED_WIDTH;
    }

    const onChooseItem = (item) => {
        props.sequencerEngine.loadPresetAsSubSequence(item);
    };

    const onSearchTextChanged = useCallback((e) => {
        setSearchText(e.target.value);
    }, [setSearchText]);

    const onClickOption = useCallback((opt) => {
        setOption(opt);
    }, [setOption]);

    /**
            <input
              value={searchText}
              className="browser-search"
              type="text"
              placeholder='Search'
              onChange={onSearchTextChanged}/>
            <div className="options">
              <Option option={PRESETS} selectedOption={option} onClick={(o) => onClickOption(o)} name="Presets"/>
              <Option option={SEQUENCES} selectedOption={option} onClick={(o) => onClickOption(o)} name="Sequences"/>
            </div>
    */ 
    return (
        <div
          style={style}
          className="side-browser-container">
         <div className="sidebar-header">
            <div
              onClick={() => toggleCollapse()}
              className="collapse-toggle">
              {collapsed ? 
                  <div className="arrow-down"/> :
                  <div className="arrow-right"/>}
            </div>
          </div>
          <ConditionedComponent condition={!collapsed}>
           <ConditionedComponent condition={option === PRESETS}>
              <div
                className="preset-folders">
                <FoldersComponent
                  sequencerEngine={props.sequencerEngine}
                  onTestItem={(preset) => []}
                  onChooseFolder={(folder) => []}
                  onChooseItem={(item) => onChooseItem(item)}
                  showItems={true}/>
              </div>
            </ConditionedComponent>
            <ConditionedComponent condition={option === SEQUENCES}>
              <div
                className="preset-folders">
                <XanaduFolders
                  sequencerEngine={props.sequencerEngine}
                  root={ethereum.xanadu.linkFolder}
                  />
              </div>
            </ConditionedComponent>
          </ConditionedComponent>
        </div>
    );
}

function Option(props) {
    let className = 'option';
    if (props.option === props.selectedOption) {
        className += ' selected';
    }

    return (
        <div
          onClick={() => props.onClick(props.option)}
          className={className}>{props.name}</div>
    );
}

const mapStateToProps = (state, props) => {
    return {
        mode: state.arrangement.browserMode
    };
};
 
export default connect(mapStateToProps, null)(SideBrowserContainer);
